import React, { useEffect, useState } from "react";
import { fetchproductdetaillist, createFavorite } from "./Apiservice";
import { Link, useParams } from "react-router-dom";
import Modal from "react-modal";
import Swal from "sweetalert2";
import { HiArrowNarrowLeft } from "react-icons/hi";
import { HiArrowNarrowRight } from "react-icons/hi";
import axios from "axios";
import { Star } from "lucide-react";
import { FaHeart } from "react-icons/fa";
import { FaRegHeart } from "react-icons/fa6";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import DOMPurify from "dompurify";
import WhatsAppChatWidget from "./WhatsAppChatWidget";

Modal.setAppElement("#root");

const ProductDetail = () => {
  const { id } = useParams();

  const [relatedProducts, setRelatedProducts] = useState([]);
  const [mainImage, setMainImage] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [productDetail, setProductDetail] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [reviewText, setReviewText] = useState("");
  const [rating, setRating] = useState(5);
  const [hoveredRating, setHoveredRating] = useState(0);

  // Assuming you'll pass userId as a prop or get it from somewhere
  const handleSubmitReview = async () => {
    if (!reviewText || rating === 0) {
      Swal.fire({
        icon: "warning",
        title: "Incomplete Review",
        text: "Please enter a review and select a star rating before submitting.",
      });
      return;
    }
    const reviewData = {
      user_id: 1, // Replace with actual user ID from your app
      product: id,
      text: reviewText,
      star_rating: rating,
    };

    try {
      const response = await axios.post(
        "https://vishushethra.com/api/api/reviews/",
        reviewData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      console.log("Review submitted:", response.data);
      Swal.fire({
        icon: "success",
        title: "Review Submitted",
        text: "Thank you for your feedback!",
      });
      // Optionally clear the form after successful submission
      setReviewText("");
      setRating(5);
    } catch (error) {
      console.error("Error submitting review:", error);

      if (
        error.response &&
        error.response.status === 400 &&
        error.response.data.error ===
          "You have already submitted a review for this product."
      ) {
        // Show specific error for duplicate review
        Swal.fire({
          icon: "error",
          title: "Duplicate Review",
          text: "You have already submitted a review for this product.",
        });
      } else {
        // Show generic error message
        Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: "An error occurred while submitting your review. Please try again.",
        });
      }
    }
  };
  const handleStarClick = (selectedRating) => {
    setRating(selectedRating);
  };

  const handleStarHover = (hoveredValue) => {
    setHoveredRating(hoveredValue);
  };

  const [visibleItems, setVisibleItems] = useState(
    window.innerWidth <= 768 ? 8 : 12,
  );

  const [selectedOptions, setSelectedOptions] = useState({
    size: "",
  });
  const [quantity, setQuantity] = useState(1);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    const updateVisibleItems = () => {
      setVisibleItems(window.innerWidth <= 768 ? 4 : 8);
    };

    window.addEventListener("resize", updateVisibleItems);

    return () => {
      window.removeEventListener("resize", updateVisibleItems);
    };
  }, []);
  useEffect(() => {
    const getProductDetails = async () => {
      try {
        const data = await fetchproductdetaillist(id);
        console.log("API Response:", data);
        setProductDetail(data);
        if (data.images && data.images.length > 0) {
          setMainImage(data.images[0].image);
        }
        if (data.related_products) {
          setRelatedProducts(data.related_products);
        }
      } catch (err) {
        console.error("Error fetching product details:", err);
      }
    };

    getProductDetails();
  }, [id]);
  const validateSelections = () => {
    return selectedOptions.size !== ""; // Only check if size is selected
  };

  const csrfToken = document.cookie
    .split("; ")
    .find((row) => row.startsWith("csrftoken="))
    ?.split("=")[1];
  axios.defaults.withCredentials = true;
  axios.defaults.headers.common["X-CSRFToken"] = csrfToken;

  const handleAddToCart = async () => {
    const userId = localStorage.getItem("userId");

    // if (!userId) {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Login Required",
    //     text: "Please log in to add products to your cart.",
    //     showCancelButton: true,
    //     confirmButtonText: "Login",
    //     cancelButtonText: "Cancel",
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       window.location.href = "/AuthForm";
    //     }
    //   });
    //   return;
    // }

    // if (!validateSelections()) {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Selection Required",
    //     text: "Please select a size before adding to cart.",
    //   });
    //   return;
    // }

    if (!productDetail || !productDetail.stock_details) {
      Swal.fire({
        icon: "error",
        title: "Product Unavailable",
        text: "Stock Unavaliable.",
      });
      return;
    }

    const selectedSize = selectedOptions.size;
    const selectedQuantity = quantity;

    const totalPrice = calculateTotalPrice();

    const optionCategories = productDetail.option_categories.map(
      (category) => ({
        id: category.id,
        name: category.name,
        value: selectedOptions[category.name.toLowerCase()] || "",
      }),
    );

    const cartData = {
      user_id: userId,
      product_id: productDetail.id,
      size: selectedSize,
      quantity: selectedQuantity,
      item_price: totalPrice,
      option: optionCategories,
    };

    try {
      const response = await fetch("https://vishushethra.com/api/api/cart/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // "X-CSRFToken": csrfToken,
        },
        body: JSON.stringify(cartData),
      });

      const data = await response.json();
      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Added to Cart",
          text: "Your product has been successfully added to the cart.",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.message || "Failed to add product to cart.",
        });
      }
    } catch (err) {
      console.error("Error adding product to cart:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Error adding product to cart.",
      });
    }
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const handleOpenModal = () => {
    setSelectedProduct(productDetail);
    setModalIsOpen(true);
  };
  const handleThumbnailClick = (src) => {
    setMainImage(src);
    setSelectedProduct(productDetail);
  };

  const calculateTotalPrice = () => {
    if (!productDetail) return 0;

    const basePrice = Number(calculateTotalDiscountPrice());

    // Get the price of the selected size, if any
    const selectedSizePrice =
      productDetail.sizes.find((size) => size.value === selectedOptions.size)
        ?.price || 0;

    // Add the selected size's price to the total
    const totalAdditionalCost = Number(selectedSizePrice);

    const totalPrice = basePrice + totalAdditionalCost * quantity;

    return Math.round(totalPrice);
  };

  const nextImage = () => {
    setCurrentImageIndex(
      (prevIndex) => (prevIndex + 1) % productDetail.images.length,
    );
  };

  const prevImage = () => {
    setCurrentImageIndex(
      (prevIndex) =>
        (prevIndex - 1 + productDetail.images.length) %
        productDetail.images.length,
    );
  };

  const calculateTotalDiscountPrice = () => {
    const originalPrice = parseFloat(productDetail.price) || 0;
    const discountPercentage = productDetail.discount_percentage || 0;
    const discount = (originalPrice * discountPercentage) / 100;
    const discountedPrice = originalPrice - discount;
    const totalPrice = discountedPrice * quantity;
    return totalPrice.toFixed(2);
  };

  const [showsizeModal, setShowsizeModal] = useState(false);

  // Function to open and close the modal
  const togglesizeModal = () => setShowsizeModal(!showsizeModal);
  const [favorites, setFavorites] = useState([]);

  const toggleFavorite = (productId) => {
    if (favorites.includes(productId)) {
      setFavorites(favorites.filter((id) => id !== productId)); // Remove from favorites
    } else {
      setFavorites([...favorites, productId]); // Add to favorites
    }
  };
  const handleAddToFavorites = async (productId) => {
    const userId = localStorage.getItem("userId"); // Get userId from local storage
    if (userId) {
      try {
        await createFavorite(userId, productId);

        Swal.fire({
          icon: "success",
          title: "Add Cart",
          text: "Product added to favorites successfully",
        });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to add favorites.",
        });
        console.error("Error adding to favorites:", error);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Login Required",
        text: "Please log in to add favorites.",
        showCancelButton: true,
        confirmButtonText: "Login",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = "/AuthForm";
        }
      });
    }
  };
  const [activeTab, setActiveTab] = useState("Review");

  const tabs = [
    { id: "Description", label: " Description" },

    { id: "additional", label: "Additional Information" },
    { id: "Review", label: "Review" },
  ];
  const StarRating = ({ rating }) => {
    return (
      <div className="flex mt-2">
        {[1, 2, 3, 4, 5].map((star) => (
          <Star
            key={star}
            size={20}
            fill={star <= rating ? "#FFD700" : "none"}
            color={star <= rating ? "#FFD700" : "#D1D5DB"}
          />
        ))}
      </div>
    );
  };
  return (
    <div>
      <h2 className="text-center my-5">PRODUCT DETAIL</h2>
      <section className="product_details mb-135">
        <div className="container">
          {productDetail ? (
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <div className="product_zoom_gallery ">
                  <div className="zoom_gallery_inner ">
                    <div className="product_zoom_main_img">
                      <div className="product_zoom_thumb">
                        <img
                          src={mainImage}
                          alt={productDetail.name}
                          style={{
                            height: "100%",
                            width: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                      <div
                        className="productdetailimagefullview-icon"
                        onClick={handleOpenModal}
                      >
                        <i className="icon-size-fullscreen icons"></i>
                      </div>
                    </div>
                    <div className="zoom_tab_img ">
                      {productDetail.images &&
                        productDetail.images.map((thumbnail, index) => (
                          <Link
                            key={index}
                            className="zoom_tabimg_list"
                            to="#"
                            onClick={() =>
                              handleThumbnailClick(thumbnail.image)
                            }
                          >
                            <img
                              src={thumbnail.image}
                              alt="tab-thumb"
                              className=""
                            />
                          </Link>
                        ))}
                      {/* {productDetail.discount_percentage > 0 && (
                        <div className="product_label">
                          <span>-{productDetail.discount_percentage}%</span>
                        </div>
                      )}
                      {productDetail.sold_out && (
                        <div className="product_label sold_out" id="sold">
                          <span>Sold Out</span>
                        </div>
                      )} */}
                      <div className="product-labels">
                        {/* {productDetail.is_bogo && (
                          <div className="product-label bogo">
                            <span>
                              Buy {productDetail.buy_quantity} Get{" "}
                              {productDetail.get_quantity}
                            </span>
                          </div>
                        )}
                        {productDetail.discount_percentage > 0 && (
                          <div className="product-label discount">
                            <span>-{productDetail.discount_percentage}%</span>
                          </div>
                        )} */}
                        {productDetail.offer_type === "buy_x_get_y" && (
                          <div className="product-label bogo">
                            <span>
                              Buy {productDetail.buy_x} Get{" "}
                              {productDetail.get_y}
                            </span>
                          </div>
                        )}
                        {productDetail.offer_type === "discount_percentage" &&
                          productDetail.discount_percentage !== "0.00" && (
                            <div className="product-label discount">
                              <span>-{productDetail.discount_percentage}%</span>
                            </div>
                          )}
                        {productDetail.sold_out && (
                          <div className="product-label sold-out">
                            <span>Sold Out</span>
                          </div>
                        )}
                        {productDetail.coming_soon && (
                          <div className="product-label coming-soon">
                            <span>Coming Soon</span>
                          </div>
                        )}
                        {productDetail.latest_collection && (
                          <div className="product-label latest">
                            <span>Trending</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 col-md-6">
                <div className="product_d_right">
                  <form onSubmit={(e) => e.preventDefault()}>
                    <h1>{productDetail.name}</h1>
                    {!productDetail.coming_soon && (
                      <div className="price_box">
                        <span className="current_price">
                          ₹
                          {/* {calculateTotalDiscountPrice().toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                        })}{" "} */}
                          {Math.ceil(
                            calculateTotalDiscountPrice(),
                          ).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                          <span style={{ fontSize: "18px" }}>INR</span>
                        </span>
                        {productDetail.discount_percentage > 0 && (
                          <span
                            className="old_price"
                            style={{ marginLeft: "10px" }}
                          >
                            ₹
                            {parseFloat(productDetail.price).toLocaleString(
                              "en-IN",
                              { minimumFractionDigits: 2 },
                            )}{" "}
                            <span style={{ fontSize: "13px" }}>INR</span>
                          </span>
                        )}
                      </div>
                    )}
                    <div className="product_desc">
                      <p>{productDetail.description}</p>
                    </div>

                    {[
                      ...(productDetail.sizes.length > 0 ? ["Size"] : []),

                      ...productDetail.option_categories.map(
                        (category) => category.name,
                      ), // Add dynamic option categories
                    ].map((option, idx) => (
                      <div
                        className="filter__list widget_size hiddenCB"
                        key={idx}
                      >
                        <h3>
                          {option === "ADD ONS" ? option : `Select ${option}`}
                        </h3>
                        <ul className="options-list">
                          {option === "Size" &&
                            productDetail.sizes.map((size) => (
                              <li key={size.id}>
                                <input
                                  type="checkbox"
                                  id={`cb_${option}_${size.value}`}
                                  value={size.value}
                                  checked={selectedOptions.size === size.value}
                                  onChange={() => {
                                    setSelectedOptions((prev) => ({
                                      ...prev,
                                      size:
                                        prev.size === size.value
                                          ? ""
                                          : size.value,
                                    }));
                                  }}
                                />
                                <label htmlFor={`cb_${option}_${size.value}`}>
                                  {size.value}{" "}
                                  {size.price !== "0.00" &&
                                    `(+${size.price}rs)`}
                                </label>
                              </li>
                            ))}

                          {productDetail.option_categories.map(
                            (category) =>
                              category.name === option &&
                              category.options.map((item) => (
                                <li key={item.id}>
                                  <input
                                    type="checkbox"
                                    id={`cb_${option}_${item.value}`}
                                    value={item.value}
                                    checked={
                                      selectedOptions[option] === item.value
                                    }
                                    onChange={() => {
                                      setSelectedOptions((prev) => ({
                                        ...prev,
                                        [option]:
                                          prev[option] === item.value
                                            ? ""
                                            : item.value,
                                      }));
                                    }}
                                  />
                                  <label htmlFor={`cb_${option}_${item.value}`}>
                                    {item.value}
                                  </label>
                                </li>
                              )),
                          )}
                        </ul>
                      </div>
                    ))}
                    {productDetail.coming_soon && (
                      <h1 style={{ color: "#67C8EA" }}>Coming Soon</h1>
                    )}

                    {!productDetail.coming_soon && (
                      <div className="filter__list widget_size ">
                        <h3>Total Price </h3>
                        <p
                          className="options-list mt-3"
                          style={{ fontSize: "25px" }}
                        >
                          ₹
                          {calculateTotalPrice().toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                          })}{" "}
                          <span style={{ fontSize: "18px" }}>INR</span>
                        </p>
                      </div>
                    )}

                    {!productDetail.coming_soon && (
                      <div className="filter__list widget_size ">
                        <h3>Dispatch time </h3>
                        <p className="options-list mt-3">
                          {productDetail.dispatch_time}
                        </p>
                      </div>
                    )}
                    {!productDetail.coming_soon && (
                      <div className="filter__list widget_size ">
                        <h3>Add quantity</h3>
                        <p className="options-list mt-2">
                          {" "}
                          <div className="pro-qty d-flex align-items-center">
                            <button
                              className="button btn btn-primary"
                              type="button"
                              onClick={() =>
                                setQuantity(Math.max(1, quantity - 1))
                              }
                            >
                              -
                            </button>
                            <input
                              type="number"
                              min="1"
                              value={quantity}
                              onChange={(e) =>
                                setQuantity(Math.max(1, Number(e.target.value)))
                              }
                              className="qty-input text-center mx-1"
                              style={{ width: "50px", border: "none" }}
                            />
                            <button
                              className="button btn btn-primary"
                              type="button"
                              onClick={() => setQuantity(quantity + 1)}
                            >
                              +
                            </button>
                          </div>
                        </p>
                      </div>
                    )}
                    {!productDetail.coming_soon && (
                      <div className="variant_quantity_btn mt-3">
                        <div className="">
                          <Link
                            className="wishlist"
                            to="#"
                            style={{ marginLeft: "10px" }}
                          >
                            <button
                              className="button btn btn-danger py-2 "
                              type="button"
                              onClick={() =>
                                handleAddToFavorites(productDetail.id)
                              }
                            >
                              <i className="ion-android-add"></i> Add to
                              Favourite
                            </button>
                          </Link>
                          <button
                            className={`button btn py-2 ${
                              productDetail.sold_out
                                ? "btn-danger"
                                : "btn-success"
                            }`}
                            type="button"
                            onClick={
                              productDetail.sold_out ? null : handleAddToCart
                            } // Disable button if sold out
                            disabled={productDetail.sold_out} // Disable button if sold out
                          >
                            {productDetail.sold_out ? (
                              <span>Sold Out</span>
                            ) : (
                              <>
                                <i className="ion-android-add"></i> Add To Cart
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          ) : (
            <div>Loading...</div>
          )}
        </div>
      </section>

      {modalIsOpen && (
        <div
          className="modal fade show"
          id="modal_box"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <button
                type="button"
                className="close mt-3"
                onClick={closeModal}
                aria-label="Close"
              >
                <span
                  aria-hidden="true"
                  style={{
                    color: "red",
                    fontSize: "40px",
                    fontWeight: "900",
                  }}
                >
                  <i className="ion-android-close"></i>
                </span>
              </button>
              <div
                className="modal_body col-lg-12 col-md-12 col-sm-12 modal_zoom_gallery"
                style={{ position: "relative" }}
              >
                <div className="product_zoom_thumb" id="productselectedmodal">
                  <img
                    src={selectedProduct.images?.[currentImageIndex]?.image} // Use currentImageIndex
                    alt={selectedProduct.name}
                    className="col-lg-12 col-md-12 col-sm-12"
                    style={{ display: "block", margin: "0 auto" }} // Center the image
                  />
                </div>
                <div
                  className="image-navigation"
                  style={{
                    position: "absolute",
                    top: "50%",
                    width: "100%",
                    transform: "translateY(-50%)",
                  }}
                >
                  <button
                    onClick={prevImage}
                    disabled={currentImageIndex === 0}
                    style={{
                      position: "absolute",
                      left: "10px",
                      zIndex: 1,
                      border: "1px solid black",
                      borderRadius: "50%",
                    }}
                  >
                    <HiArrowNarrowLeft />
                  </button>
                  <button
                    onClick={nextImage}
                    disabled={
                      currentImageIndex === selectedProduct.images?.length - 1
                    }
                    style={{
                      position: "absolute",
                      right: "10px",
                      zIndex: 1,
                      border: "1px solid black",
                      borderRadius: "50%",
                    }}
                  >
                    <HiArrowNarrowRight />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="max-w-6xl mx-auto bg-white container mb-5">
        <div className="product_info_button border-bottom">
          <ul className="nav" role="tablist">
            {tabs.map((tab) => (
              <li key={tab.id}>
                <a
                  href={`#${tab.id}`}
                  role="tab"
                  aria-controls={tab.id}
                  aria-selected={activeTab === tab.id ? "true" : "false"}
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveTab(tab.id);
                  }}
                  className={`${
                    activeTab === tab.id
                      ? "active text-blue-600 border-b-2 border-blue-600 bg-blue-50"
                      : "text-gray-500 hover:text-gray-700 hover:bg-gray-50"
                  }`}
                >
                  {tab.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="px-6 py-8">
          {activeTab === "Description" && (
            <div className="prose max-w-none">
              <div
                className="content"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(productDetail.product_details),
                }}
              ></div>
            </div>
          )}

          {activeTab === "additional" && (
            <div className="space-y-8">
              <p
                className="content"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(productDetail.additional_info),
                }}
              ></p>
            </div>
          )}

          {activeTab === "Review" && (
            <div className="review-main">
              <div className="w-1 p-4  custom-review">
                <h2 className="text-2xl font-bold mb-4 text-gray-900">
                  Customer Reviews
                </h2>
                {productDetail?.reviews?.length > 0 ? (
                  productDetail.reviews.map((review, index) => (
                    <div key={index} className="border-b pb-4 mb-4">
                      <div className="flex justify-between items-center">
                        <span className="font-semibold text-gray-900">
                          {review.user}
                        </span>
                        <span className="text-sm text-gray-500">
                          {new Date(review.created_at).toLocaleDateString()}
                        </span>
                      </div>
                      <p className="text-gray-700">{review.text}</p>

                      <StarRating rating={review.star_rating} />
                    </div>
                  ))
                ) : (
                  <p className="text-gray-500">
                    No reviews yet. Be the first to review!
                  </p>
                )}
              </div>

              <div className="w-1/2 p-4  leave-review">
                <h2 className="text-2xl font-bold mb-4 text-gray-900">
                  Leave a Review
                </h2>
                <textarea
                  value={reviewText}
                  onChange={(e) => setReviewText(e.target.value)}
                  placeholder="Write your review..."
                  className="border border-gray-300 p-3 w-full rounded focus:outline-none focus:border-gray-400 mb-4 min-h-[100px] resize-none"
                />
                <div className="mb-4">
                  <label className="block text-gray-900 mb-2">Rating</label>
                  <div className="flex items-center gap-2">
                    <div
                      className="flex"
                      onMouseLeave={() => setHoveredRating(0)}
                    >
                      {[1, 2, 3, 4, 5].map((value) => (
                        <button
                          key={value}
                          type="button"
                          onClick={() => handleStarClick(value)}
                          onMouseEnter={() => handleStarHover(value)}
                          className="focus:outline-none p-0.5 hover:scale-105 transition-transform"
                          style={{
                            border: "none",
                            backgroundColor: "transparent",
                          }}
                        >
                          <Star
                            size={24}
                            fill={
                              (hoveredRating || rating) >= value
                                ? "#FFD700"
                                : "none"
                            }
                            color={
                              (hoveredRating || rating) >= value
                                ? "#FFD700"
                                : "#D1D5DB"
                            }
                            strokeWidth={1.5}
                            className="transition-colors duration-150"
                          />
                        </button>
                      ))}
                    </div>
                    <span className="text-gray-900 text-sm">
                      {rating} out of 5 stars
                    </span>
                  </div>
                </div>
                <button
                  onClick={handleSubmitReview}
                  className="border border-gray-300 text-gray-900 font-normal py-2 px-4 rounded hover:bg-gray-50 transition-colors duration-200"
                >
                  Submit Review
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <section className="product_area related_products mb-118">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="section_title mb-50">
                <h2>Related Products </h2>
              </div>
            </div>
          </div>
          <div className="grid-container">
            {[...relatedProducts]
              .reverse()
              .slice(0, visibleItems)
              .map((product) => {
                const originalPrice = parseFloat(product.price);

                const discountedPrice =
                  originalPrice -
                  (originalPrice * product.discount_percentage) / 100;

                return (
                  <div key={product.id} className="grid-item">
                    <div className="product-thumb">
                      <Link to={`/Productdetail/${product.id}`}>
                        {/* Primary Image */}
                        <img
                          className="primary-img"
                          src={product.images[0].image}
                          alt={product.name}
                        />
                        {/* Secondary Image (Only show if available) */}
                        {product.images[1] && (
                          <img
                            className="secondary-img"
                            src={product.images[1].image}
                            alt={`${product.name} hover`}
                          />
                        )}
                      </Link>
                      {/* Discount or Sold-Out Labels */}
                      {/* {product.discount_percentage > 0 && (
                        <div className="product-label">
                          <span>-{product.discount_percentage}%</span>
                        </div>
                      )}
                      {product.sold_out && (
                        <div className="product-label sold-out">
                          <span>Sold Out</span>
                        </div>
                      )} */}

                      <div className="product-labels">
                        {/* {product.is_bogo && (
                          <div className="product-label bogo">
                            <span>
                              Buy {product.buy_quantity} Get{" "}
                              {product.get_quantity}
                            </span>
                          </div>
                        )}
                        {product.discount_percentage > 0 && (
                          <div className="product-label discount">
                            <span>-{product.discount_percentage}%</span>
                          </div>
                        )} */}
                        {product.offer_type === "buy_x_get_y" && (
                          <div className="product-label bogo">
                            <span>
                              Buy {product.buy_x} Get {product.get_y}
                            </span>
                          </div>
                        )}
                        {product.offer_type === "discount_percentage" &&
                          product.discount_percentage !== "0.00" && (
                            <div className="product-label discount">
                              <span>-{product.discount_percentage}%</span>
                            </div>
                          )}
                        {product.sold_out && (
                          <div className="product-label sold-out">
                            <span>Sold Out</span>
                          </div>
                        )}
                        {product.coming_soon && (
                          <div className="product-label coming-soon">
                            <span>Coming Soon</span>
                          </div>
                        )}
                        {product.latest_collection && (
                          <div className="product-label latest">
                            <span>Trending</span>
                          </div>
                        )}
                      </div>
                      {/* Product Actions */}
                      <div className="product-action">
                        <ul>
                          <li
                            className="wishlist"
                            onClick={() => {
                              handleAddToFavorites(product.id);
                              toggleFavorite(product.id);
                            }}
                          >
                            <Link to="" title="Wishlist">
                              {favorites.includes(product.id) ? (
                                <FaHeart className="wishlist-icon active" />
                              ) : (
                                <FaRegHeart className="wishlist-icon" />
                              )}
                            </Link>
                          </li>
                          <li className="quick-view">
                            <Link
                              data-toggle="modal"
                              data-target="#modal_box"
                              title="Quick View"
                              to="#"
                              onClick={() => setSelectedProduct(product)}
                            >
                              <i className="icon-size-fullscreen icons"></i>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="product-content">
                      <h4 className="product-name">
                        <Link to={`/Productdetail/${product.id}`}>
                          {product.name}
                        </Link>
                      </h4>{" "}
                      {!product.coming_soon && (
                        <div className="price-box">
                          <span className="current-price">
                            ₹
                            {discountedPrice.toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                            })}{" "}
                            <span className="inr">INR</span>
                          </span>
                          {product.discount_percentage > 0 && (
                            <span className="old-price">
                              ₹
                              {originalPrice.toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                              })}{" "}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </section>

      <WhatsAppChatWidget
        phoneNumber="+918939711577"
        companyName="VishuShethra Industries"
      />
    </div>
  );
};

export default ProductDetail;
